import React from "react";
import { Badge, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import orderPending from "../../../../../images/return.png";
import orderCancel from "../../../../../images/cancelled.png";
import orderCompleted from "../../../../../images/check.png";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";

const Item = ({ item, moduleConfig }) => {
  const getOrderStatusBadge = (status) => {
    if (status === "0" || status === 0)
      return (
        <badge
          bg="warning"
          className="font-small badge badge-pill badge-custom-8 text-dark"
        >
          Processing
        </badge>
      );
    if (status === "1" || status === 1)
      return (
        <badge
          bg="success"
          className="font-small badge  badge-pill badge-custom-7"
        >
          Completed
        </badge>
      );
    if (status === "2" || status === 2)
      return (
        <badge
          bg="danger"
          className="font-small badge badge-pill badge-custom-3"
        >
          Cancelled
        </badge>
      );
    return (
      <badge bg="secondary" className="font-small badge badge-custom-1">
        Unknown
      </badge>
    );
  };

  const getPaymentBadge = (status) => (
    <Badge bg={status ? "success" : "warning"} className="badge-pill">
      {status ? "Paid" : "Pending"}
    </Badge>
  );
  const statusBadge = {
    0: (
      <Badge bg="warning" text="dark">
        Pending
      </Badge>
    ),
    1: <Badge bg="success">Approved</Badge>,
    2: <Badge bg="danger">Rejected</Badge>,
  };
  const getOrderImage = () => {
    if (item.status === "0") return orderPending;
    if (item.status === "2") return orderCancel;
    return orderCompleted;
  };

  return (
    <tr className="align-middle">
      <td className="p-2">
        <Image
          src={getOrderImage()}
          rounded
          width={32}
          height={32}
          className="object-fit-contain"
        />
      </td>
      <td className=" font-mono">{item?.order?.orderId}</td>
      <td className="text-truncate d-flex flex-column">
        <p className="mb-0">{item.customer?.fullName || "-"}</p>
        <p className="mb-0 text-custom-4 text-muted">
          {" "}
          <ModuleDisplayEmail value={item.customer?.email} />
        </p>
      </td>
      <td className="text-center text-bold">{item.product?.title || "-"}</td>
      <td className="text-center italic small">
        <ModuleDisplayDate value={item.date} />
      </td>
      <td className="text-center">
        <div className="">
          {statusBadge[item.status] || <Badge bg="secondary">Unknown</Badge>}
        </div>
      </td>

      <td className="text-center p-2">
        <Link
          to={`/returns/${item._id}`}
          className="btn btn-outline-secondary btn-sm"
          title={`View ${moduleConfig.singleItemTitle}`}
        >
          <i className="fas fa-eye" />
        </Link>
      </td>
    </tr>
  );
};

export default Item;
